
define('text!modules/targeting/video/templates/bin_group_item.html',[],function () { return '<div class="video-targeting type">\n    <div  class="item-c text">{{{name}}}</div>\n</div>\n';});

